import type { EventTransport, WidgetEventEnvelope } from "./transport";

type FetchLike = (
  input: string,
  init: {
    method: string;
    headers: Record<string, string>;
    body: string;
    keepalive: boolean;
  },
) => Promise<unknown>;

export interface FetchTransportOptions {
  url: string | (() => string);
  headers?: () => Record<string, string> | Promise<Record<string, string>>;
  serializeBody?: (envelope: WidgetEventEnvelope) => unknown;
  fetchImpl?: FetchLike;
}

export function createFetchTransport(
  options: FetchTransportOptions,
): EventTransport {
  return async (envelope) => {
    const url = typeof options.url === "function" ? options.url() : options.url;
    const extraHeaders = options.headers ? await options.headers() : undefined;
    const body = options.serializeBody
      ? options.serializeBody(envelope)
      : envelope;
    const fetchImpl =
      options.fetchImpl ?? (globalThis as { fetch: FetchLike }).fetch;
    await fetchImpl(url, {
      method: "POST",
      headers: { "content-type": "application/json", ...extraHeaders },
      body: JSON.stringify(body),
      keepalive: true,
    });
  };
}
